import React from 'react';
import { Link } from 'react-router-dom';

import Paragraph from 'pages/Landings/components/Paragraph';

import useStyles from './styles';

type LinkProps =
    | {
          to: string;
          href?: never;
      }
    | {
          to?: never;
          href: string;
      };

type BaseProps = {
    title: React.ReactNode;
    icon: React.ReactNode;
    className?: string;
};

type Props = BaseProps & LinkProps;

const Card: React.FC<Props> = ({ title, href, to, icon, className }) => {
    const { classes, cx } = useStyles();
    const Component: React.ElementType = href ? 'a' : Link;
    const props = href ? { href, target: '_blank', rel: 'noopener noreferrer' } : { to };
    return (
        <Component {...props} className={cx(classes.root, className)}>
            <span className={classes.icon}>{icon}</span>
            <Paragraph primary={title} className={classes.title} />
        </Component>
    );
};

export default Card;
